<template>
  <div>
    <ul class="lista-downloads">
      <a name="listaAR"></a><li class="prod">AR - Autoridades de Registro</li>
      <li>
        Para filtrar a lista de AR's, digite abaixo o nome da AR desejada.
        <br/>
        Filtrar: <input type="text" size="40" style="border: solid 1px #f0f0f0; color: #9ca9a6;"  v-model.lazy.trim="filtroAR">
        <span></span>
      </li>

      <li v-if="ars.length>0" v-for="ar,ar_index in ars">
        <a :href="ar.site" target="_blank">{{ ar.nome }}</a>
        <mark v-if="ar.descredenciada" style="color:#FF0000">(DESCREDENCIADA)</mark>
				<span>
          <strong v-if="acs[acselecionada].documentos.pc">
            PC implementada: {{ ar.pc }}<br>
          </strong>
          {{ ar.endereco.linha1 }}<br>
          {{ ar.endereco.linha2 }}<br>
          <br>
          <template v-if="!ar.descredenciada">Solicitar, Emitir, </template>Alterar senha ou Revogar certificados:
          <a :href="ar.linkSistema" target="sistema_ar" style="font-size: 11px;">[clique aqui]</a>

          <template v-if="ar.instalacaotecnica">
            <br><br>
            <strong v-if="ar.instalacaotecnica.length > 1">Instalações Técnicas:</strong>
            <strong v-else-if="ar.instalacaotecnica.length == 1">Instalação Técnica:</strong>
            <template v-for="it,it_index in ar.instalacaotecnica">
              <br>
              <AccordionMenu v-if="it.nome" :contents="getAccordion(it.nome,it.endereco.linha1,it.endereco.linha2,it.situacao)"></AccordionMenu>
            </template>
          </template>

          <template v-if="ar.instalacaotecnicasecundaria">
            <br><br>
            <strong v-if="ar.instalacaotecnicasecundaria.length > 1">Instalações Técnicas Secundárias:</strong>
            <strong v-else-if="ar.instalacaotecnicasecundaria.length == 1">Instalação Técnica Secundária:</strong>
            <template v-for="its in ar.instalacaotecnicasecundaria">
              <br>
              <AccordionMenu v-if="its.nome" :contents="getAccordion(its.nome,its.endereco.linha1,its.endereco.linha2,its.situacao)"></AccordionMenu>
            </template>
          </template>

          <template v-if="ar.postoprovisorio">
            <br><br>
            <strong v-if="ar.postoprovisorio.length > 1">Postos Provisórios:</strong>
            <strong v-else-if="ar.postoprovisorio.length == 1">Posto Provisório:</strong>
            <template v-for="pp in ar.postoprovisorio">
              <br>
              <AccordionMenu v-if="pp.nome" :contents="getAccordion(pp.nome,pp.endereco.linha1,pp.endereco.linha2,pp.situacao)"></AccordionMenu>
            </template>
          </template>


        </span>
      </li>

    </ul>
  </div>
</template>

<script>
    
import AccordionMenu from './../AccordionMenu.vue';
import { EventBus } from '../main';

export default {
  props: [
    'acselecionada'
  ],
  components: {
     AccordionMenu
  },
  data: function() {
    return {
        filtroAR: ""
     }
  },
  watch: {
    filtroAR( valor ) {
      EventBus.nomeAR = valor;
    }
  },
  computed: {
    ars() {
      //console.log('Computed: RepositorioAR ars');
      /**
        Preparar Array com as ARs para o v-for
        Listar apenas as ARs credenciadas na AC selecionada
      */
      const resultArray = [];
      for( let key in EventBus.ars ) {
        const item = EventBus.ars[key];
        item._key = key;
        // Verificar se a AR está credenciada na AC selecionada
        if( item.ac.indexOf( this.acselecionada ) >= 0 ) {
          // Filtrar pelo nome da AR
          if( EventBus.nomeAR != '' && item.nome.toLowerCase().indexOf(EventBus.nomeAR.toLowerCase()) == -1 )
            continue;

          resultArray.push( item );
        }
      }
      return resultArray;
    },
    acs() {
      //console.log('Computed: RepositorioAR acs');
      return EventBus.acs;
    }
  },
  methods: {
      getAccordion(title,msg1,msg2,situacao){
        return [
            {
                title: title,
                msg1: msg1,
                msg2: msg2,
                situacao: situacao,
            }
        ];
     }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// RepositorioAR.vue?30e04070